import styled, { css } from 'styled-components';
import { DaypickerWrapper } from 'common/DateCalander/DayPicker/Styles';

export const DayPickerHotelWrap = styled(DaypickerWrapper)`
  position: absolute;
  top: 34px;
  background-color: #ffffff;
	z-index: 1;
	${(props) => props.isMobile && css`
		position: fixed;
		top: 80px;
		left: 50%;
		transform: translateX(-50%);
		.DayPicker-Months{
			max-width: 95vw;
			& .DayPicker-Month:last-child {
				margin-top: 20px !important
			}
		}
	`}
  .DayPicker{
    border-radius: 4px;
    box-shadow: 0 1px 6px 0 rgba(0, 0, 0, 0.2);
  }

  .DayPicker-wrapper{
		outline:0;
		padding: 0;
  }
  .DayPicker-Weekday{
    color: #9b9b9b;
    font-weight: bold;
  }

  .DayPicker-Caption{
    text-align: center;
    margin-bottom: 30px;
    >div{
      font-size: 20px;
      font-weight: bold;
      color: #000;
    }
  }

  .DayPicker-Day{
    border-radius: 0;
	}
	
	.DayPicker-Day--selected:not(.DayPicker-Day--disabled):not(.DayPicker-Day--outside){
		border-radius: 0;
    background-color: #f17531;
    color: #fff;
    outline: 0;
	}
`;
